"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Direction = exports.MarketShiftOutlook = exports.ChartType = exports.TableGroupingType = exports.TickDirection = exports.AccountType = exports.MarginType = exports.CurrencyType = exports.Currency = exports.TableTab = exports.PositionType = exports.CheckedState = exports.ImpliedVolatilityType = exports.OptionType = void 0;
var OptionType;
(function (OptionType) {
    OptionType["CALL"] = "CALL";
    OptionType["PUT"] = "PUT";
})(OptionType = exports.OptionType || (exports.OptionType = {}));
var ImpliedVolatilityType;
(function (ImpliedVolatilityType) {
    ImpliedVolatilityType["STICKY_STRIKE"] = "STICKY_STRIKE";
    ImpliedVolatilityType["STICKY_DELTA"] = "STICKY_DELTA";
})(ImpliedVolatilityType = exports.ImpliedVolatilityType || (exports.ImpliedVolatilityType = {}));
var CheckedState;
(function (CheckedState) {
    CheckedState["CHECKED"] = "CHECKED";
    CheckedState["INDETERMINATE"] = "INDETERMINATE";
    CheckedState["UNCHECKED"] = "UNCHECKED";
})(CheckedState = exports.CheckedState || (exports.CheckedState = {}));
var PositionType;
(function (PositionType) {
    PositionType["Option"] = "OPTION";
    PositionType["Future"] = "FUTURE";
    PositionType["InversePerpetual"] = "INVERSE_PERPETUAL";
    PositionType["LinearPerpetual"] = "LINEAR_PERPETUAL";
    PositionType["VolatilityFuture"] = "VOLATILITY_FUTURE";
    PositionType["LinearOption"] = "LINEAR_OPTION";
    PositionType["LinearFuture"] = "LINEAR_FUTURE";
})(PositionType = exports.PositionType || (exports.PositionType = {}));
var TableTab;
(function (TableTab) {
    TableTab["PORTFOLIO_TAB"] = "PORTFOLIO_TAB";
    TableTab["MARGIN_TAB"] = "MARGIN_TAB";
})(TableTab = exports.TableTab || (exports.TableTab = {}));
// Duplicated from graphql.tsx
var Currency;
(function (Currency) {
    Currency["BTC"] = "BTC";
    Currency["ETH"] = "ETH";
    Currency["SOL"] = "SOL";
    Currency["USD"] = "USD";
    Currency["USDC"] = "USDC";
    Currency["ALL"] = "ALL";
    Currency["XRP"] = "XRP";
    Currency["ADA"] = "ADA";
    Currency["ALGO"] = "ALGO";
    Currency["BNB"] = "BNB";
    Currency["AVAX"] = "AVAX";
    Currency["BCH"] = "BCH";
    Currency["DOT"] = "DOT";
    Currency["DOGE"] = "DOGE";
    Currency["LINK"] = "LINK";
    Currency["LTC"] = "LTC";
    Currency["MATIC"] = "MATIC";
    Currency["SHIB"] = "SHIB";
    Currency["TRX"] = "TRX";
    Currency["UNI"] = "UNI";
    Currency["BTCDVOL"] = "BTCDVOL";
    Currency["ETHDVOL"] = "ETHDVOL";
})(Currency = exports.Currency || (exports.Currency = {}));
var CurrencyType;
(function (CurrencyType) {
    CurrencyType["CRYPTO"] = "CRYPTO";
    CurrencyType["FIAT"] = "FIAT";
})(CurrencyType = exports.CurrencyType || (exports.CurrencyType = {}));
var MarginType;
(function (MarginType) {
    MarginType["SM"] = "SM";
    MarginType["PM"] = "PM";
})(MarginType = exports.MarginType || (exports.MarginType = {}));
// TODO move to BE
var AccountType;
(function (AccountType) {
    AccountType["MAIN"] = "main";
    AccountType["SUBACCOUNT"] = "subaccount";
})(AccountType = exports.AccountType || (exports.AccountType = {}));
// Duplicated from graphql.tsx
var PortfolioType;
(function (PortfolioType) {
    PortfolioType["Real"] = "REAL";
    PortfolioType["Simulated"] = "SIMULATED";
    PortfolioType["Imported"] = "IMPORTED";
    PortfolioType["Unauthenticated"] = "UNAUTHENTICATED";
    PortfolioType["Shared"] = "SHARED";
})(PortfolioType || (PortfolioType = {}));
var TickDirection;
(function (TickDirection) {
    TickDirection["UP"] = "UP";
    TickDirection["SAME"] = "SAME";
    TickDirection["DOWN"] = "DOWN";
})(TickDirection = exports.TickDirection || (exports.TickDirection = {}));
var TableGroupingType;
(function (TableGroupingType) {
    TableGroupingType["ACCOUNT_UUID"] = "accountUuid";
    TableGroupingType["EXPIRY"] = "expiry";
    TableGroupingType["PORTFOLIO_UUID"] = "portfolioUuid";
    TableGroupingType["POSITION_TYPE"] = "positionType";
    TableGroupingType["CURRENCY"] = "currency";
})(TableGroupingType = exports.TableGroupingType || (exports.TableGroupingType = {}));
var ChartType;
(function (ChartType) {
    ChartType["Equity"] = "EQUITY";
    ChartType["ChangePnl"] = "CHANGE_PNL";
    ChartType["Pnl"] = "PNL";
})(ChartType = exports.ChartType || (exports.ChartType = {}));
var MarketShiftOutlook;
(function (MarketShiftOutlook) {
    MarketShiftOutlook["UP"] = "up";
    MarketShiftOutlook["DOWN"] = "down";
    MarketShiftOutlook["SAME"] = "same";
})(MarketShiftOutlook = exports.MarketShiftOutlook || (exports.MarketShiftOutlook = {}));
var Direction;
(function (Direction) {
    Direction["BUY"] = "BUY";
    Direction["SELL"] = "SELL";
})(Direction = exports.Direction || (exports.Direction = {}));
